import { TOGGLE_DISTRIBUTION_DETAILS_DRAWER, TOGGLE_DISTRIBUTION_DRAWER } from "@/redux/types";
import { updateStateHandler } from "@/utils";

const initialState = {
    openDetailsDrawer: false,
    openDrawer: false,
};

const toggleDistributionDrawer = (state, open) => updateStateHandler(state, { openDrawer: open });

const toggleDistributionDetailsDrawer = (state, open) => updateStateHandler(state, { openDetailsDrawer: open });

const distributionsReducer = (state = initialState, action) => {
    const { payload, type } = action;

    const { open } = payload || {};

    if (type === TOGGLE_DISTRIBUTION_DRAWER) {
        return toggleDistributionDrawer(state, open);
    }

    if (type === TOGGLE_DISTRIBUTION_DETAILS_DRAWER) {
        return toggleDistributionDetailsDrawer(state, open);
    }

    return state;
};

export default distributionsReducer;
